// extracted by mini-css-extract-plugin
export default {"typeahead":"Typeahead_typeahead__w-6HU","typeahead__textbox":"Typeahead_typeahead__textbox__W8Wv6"};